export enum GlobalDialogReducer {
  SHOW_DIALOG = 0,
  UPDATE_DIALOG,
  HIDE_DIALOG,
  HIDE_ALL_DIALOGS,
}
